export const formatTimeDate = (string) => {
	if (!string || string.length<1){
		return "";
	}
	const [ mDate, mTime ] = string.split(' ');
	return `${mDate.split("-").join(".")}${ mTime ? ' '+mTime : ''}`;
};

export const removeHoursFromDate = (string) => {
	if (!string || string.length<1){
		return "";
	}

	const splited =  string.split(' ');

	return splited[0];
};